/* Ripost « Avis à la une » — toggle for the full Judge.me list + pagination (22/10/2026, V2 23/10: pagination fix also runs when no block is rendered).
   Pagination: the Judge.me app embed is not enabled on this theme (jdgmSettings error), so the legacy
   pagination buttons do nothing. We call the same public endpoint the widget uses and swap the list. */
(function(){
  var SHOP="se1m5y-69.myshopify.com",API="https://api.judge.me/reviews/reviews_for_widget";
  function root(){return document.getElementById("judgeme_product_reviews")}
  function fr(d){try{return new Date(d.replace(" UTC","Z").replace(" ","T")).toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric"})}catch(e){return""}}
  function reskin(w){
    w.querySelectorAll(".jdgm-rev__timestamp").forEach(function(e){if(e.dataset.content){e.textContent=fr(e.dataset.content);e.classList.remove("jdgm-spinner")}});
    w.querySelectorAll(".jdgm-rev").forEach(function(r){
      if(r.dataset.verifiedBuyer==="true"){var b=r.querySelector(".jdgm-rev__buyer-badge");b&&(b.textContent="Achat vérifié",b.classList.add("rp-verified"))}
      var body=(r.querySelector(".jdgm-rev__body")||{}).textContent||"",ti=(r.querySelector(".jdgm-rev__title")||{}).textContent||"";
      !body.trim()&&!ti.trim()&&!r.querySelector(".jdgm-rev__pic-img")&&r.classList.add("rp-empty")});
    w.querySelectorAll("img[data-src]").forEach(function(i){i.getAttribute("src")||(i.src=i.dataset.src.replace("width=160","width=400"),i.loading="lazy")});
    w.querySelectorAll(".jdgm--loading").forEach(function(e){e.classList.remove("jdgm--loading")});
  }
  function count(){var r=root(),w=r&&r.querySelector(".jdgm-rev-widg");return w?(+w.dataset.numberOfReviews||0):null}
  function pag(r){
    r.addEventListener("click",function(ev){
      var b=ev.target.closest(".jdgm-paginate__page");if(!b||!r.contains(b))return;
      ev.preventDefault();ev.stopImmediatePropagation();
      var page=+b.dataset.page,pg=b.closest(".jdgm-paginate"),per=(pg&&pg.dataset.perPage)||5,list=r.querySelector(".jdgm-rev-widg__reviews");
      if(!page||!list||b.classList.contains("jdgm-curt"))return;
      r.classList.add("rp-aul-loading");
      fetch(API+"?url="+SHOP+"&shop_domain="+SHOP+"&platform=shopify&page="+page+"&per_page="+per+"&product_id="+encodeURIComponent(r.dataset.productId))
      .then(function(x){return x.json()}).then(function(d){
        var tmp=document.createElement("div");tmp.innerHTML=d.html||"";
        var nl=tmp.querySelector(".jdgm-rev-widg__reviews"),np=tmp.querySelector(".jdgm-paginate");
        if(nl)list.replaceWith(nl);if(np&&pg)pg.replaceWith(np);
        reskin(r);r.classList.remove("rp-aul-loading");
        var top=r.querySelector(".jdgm-rev-widg__body")||r;top.scrollIntoView({behavior:"smooth",block:"start"});
      }).catch(function(){r.classList.remove("rp-aul-loading")});
    },true);
  }
  function init(){
    var r=root();if(!r||r.dataset.rpAulPag)return;r.dataset.rpAulPag=1;
    pag(r);
    var sec=document.getElementById("rp-avis-une");if(!sec)return;
    var btn=sec.querySelector(".rp-aul__toggle"),lab=sec.querySelector(".rp-aul__toggle-label");
    var n=count();if(n!==null){btn.dataset.count=n;btn.hidden=!n}
    var N=function(){return btn.dataset.count};
    lab.textContent="Voir tous les avis ("+N()+")";
    btn.addEventListener("click",function(){
      var open=btn.getAttribute("aria-expanded")!=="true";
      btn.setAttribute("aria-expanded",open?"true":"false");
      r.classList.toggle("rp-aul-open",open);
      lab.textContent=open?"Masquer les avis":"Voir tous les avis ("+N()+")";
      if(open){var w=r.querySelector(".jdgm-rev-widg");w&&w.setAttribute("tabindex","-1");w&&w.focus({preventScroll:true})}
    });
  }
  document.readyState!=="loading"?init():document.addEventListener("DOMContentLoaded",init);
})();
